import comparator from "./comparator";

const byAlphabet = comparator((a, b) => a.localeCompare(b) <= 0);

export default byAlphabet;
